define([
    "./gatewayModule",
    "require",
    "text!./integration/gatewayIntegrationView.html"
], function (
    app,
    require,
    gatewayIntegrationTemplate
) {
    "use strict";

    app.config(["$stateProvider", function ($stateProvider) {

        $stateProvider
            .state("gateway.integration", {
                url: "/regional-integration-configuration",
                controller: "GatewayIntegrationController",
                template: gatewayIntegrationTemplate,
                data: {
                    group: "group.r2.configuration.advanced",
                    pageTitle: "{{'gateway.integration.config.title' | translate}}"
                },
                resolve: {
                    configurations: ["gatewayService", "remoteExceptionHandler", function (gatewayService, remoteExceptionHandler) {
                        return gatewayService.findConfigurations().then((configurations) => configurations).catch(remoteExceptionHandler());
                    }]
                }
            })
    }]);
});
